import Plyr from 'plyr';
import {secondsToTime} from "./utils"

class LightBoxVideo {

    constructor(wrapper) {

        const playerElement = wrapper?.querySelector('.js-pa-player')

        const hiddenClass = 'pa_video_hidden';

        if (wrapper && playerElement) {
            const player = new Plyr(playerElement, {
                controls: [
                    'play',
                    'progress',
                    'current-time',
                    'duration',
                    'mute',
                    'volume',
                    'settings',
                    'fullscreen',
                ]
            });

            if (player) {
                const playButton = wrapper.querySelector('.js-pa-video-play-button')
                const thumbnails = wrapper.querySelectorAll('.js-pa-video-thumbnail')
                const durationEl = wrapper.querySelector('.js-pa-video-duration');

                player.on('ready', () => {
                    durationEl.innerHTML = secondsToTime(player.duration)
                })

                playButton.addEventListener('click', () => {
                    player.play()
                })

                player.on('play', () => {
                    Array.from(thumbnails).map(item => {
                        item.classList.add(hiddenClass)
                    })
                })

                player.on('pause', () => {
                    durationEl.innerHTML = secondsToTime(player.currentTime)
                    Array.from(thumbnails).map(item => {
                        item.classList.remove(hiddenClass)
                    })
                })

                player.on('ended', () => {
                    Array.from(thumbnails).map(item => {
                        item.classList.remove(hiddenClass)
                    })
                })
            }

        }

    }
}

export default LightBoxVideo